import { tv } from "tailwind-variants";

export const strikeThrough = tv({
    base: [
        "tw:relative tw:block tw:w-fit",
        "tw:before:content-['']",
        "tw:before:absolute",
        "tw:before:left-0",
        "tw:before:top-[45%]",
        "tw:before:w-full",
        "tw:before:border-t-[0.0625em]",
        "tw:before:border-inherit",
        "tw:before:skew-y-10"
    ],

    variants: {
        size: {
            xs: "tw:text-xs tw:min-h-3.5 tw:leading-3.5",
            sm: "tw:text-xs tw:min-h-3.5 tw:leading-3.5",
            md: "tw:text-sm tw:min-h-4.5 tw:leading-4.5",
            lg: "tw:min-h-5 tw:leading-5",
            xl: "tw:min-h-6 tw:leading-6"
        }
    },

    defaultVariants: {
        size: "md"
    }
});
